export default {"src":"/_next/static/media/disasterRecovery.961513ad.svg","height":1180,"width":1451,"blurWidth":0,"blurHeight":0};